/* eslint-disable camelcase */

export const ONBOARDING_QUESTION = 'onboarding';
export const ONBOARDING_FINISHED = 'finished';

export const USER_TYPE_QUESTION = 'user_type';
export const RENTAL_TRAINING_QUESTION = 'training';

export const FEATURE_QUESTION = 'feature';
export const FEATURE_RENTAL = 'rental';
export const FEATURE_BACKGROUND_CHECK = 'background_check';
export const FEATURE_ATLAS = 'atlas';
export const FEATURE_CONTRACT = 'contract';
export const featureAnswers = [
    FEATURE_ATLAS,
    FEATURE_BACKGROUND_CHECK,
    FEATURE_RENTAL,
    FEATURE_CONTRACT,
] as const;
export type FeatureAnswer = (typeof featureAnswers)[number];

export const targetPlans = ['essential'] as const;
export type TargetPlan = (typeof targetPlans)[number];

export const USER_OBJECTIVE_QUESTION = 'user_objective';
export const USER_OBJECTIVE_CHECK_CPF = 'check_cpf';
export const USER_OBJECTIVE_IMPROVE_BUSINESS = 'improve_business';
export type UserObjectiveAnswer =
    | typeof USER_OBJECTIVE_CHECK_CPF
    | typeof USER_OBJECTIVE_IMPROVE_BUSINESS;

export const WORKS_WITH_REAL_ESTATE_QUESTION = 'works_with_real_estate';
export const WORKS_WITH_REAL_ESTATE = 'works_with_real_estate';
export const DOESNT_WORK_WITH_REAL_ESTATE = 'doesnt_work_with_real_estate';
export type WorksWithRealEstateAnswer =
    | typeof WORKS_WITH_REAL_ESTATE
    | typeof DOESNT_WORK_WITH_REAL_ESTATE;

export const onboardingSteps = [
    'userObjective',
    'worksWithRealEstate',
    'jobSelection',
    'otherJob',
    'featureSelection',
    'phoneUpdate',
    'phoneSet',
    'whatsAppAcceptContent',
    'phoneValidation',
    'whatsAppRejected',
    'finish',
] as const;

export type OnboardingStep = (typeof onboardingSteps)[number];
